export const MY_ACCOUNT_PAGE_WIDGET_ID = '14dd1af6-3e02-63db-0ef2-72fbc7cc3136';

export const ABOUT_PAGE_WIDGET_ID = '14dbefb9-3b7b-c4e9-53e8-766defd30587';

export const FOLLOWERS_FOLLOWING_WIDGET_ID =
  '14ebe825-b273-0d5f-0fd1-e6293322b83b';
